'use strict';

const { get } = require("lodash");

const API_VERSION = 2;
const API_VALID_VERSIONS = [1, 2];

const MAJOR = 3;    // Milestones
const MINOR = 20;    // Features, Enhancements
const PATCHES = 7;  // Hotfixes, Fast Track

const APP_VERSION = `${MAJOR}.${MINOR}.${PATCHES}`;
const VIEWS = {
    BT: 'BT',
    ADMIN: 'ADMIN',
}

const defaultRefresh = { [VIEWS.BT]: true, [VIEWS.ADMIN]: true };

const refreshByVersion = {
    '3.19.0': { [VIEWS.BT]: true, [VIEWS.ADMIN]: true },
    '3.19.1': { [VIEWS.BT]: false, [VIEWS.ADMIN]: false },
    '3.19.2': { [VIEWS.BT]: false, [VIEWS.ADMIN]: false },
    '3.19.3': { [VIEWS.BT]: false, [VIEWS.ADMIN]: false },
    '3.19.4': { [VIEWS.BT]: false, [VIEWS.ADMIN]: false },
    '3.19.5': { [VIEWS.BT]: false, [VIEWS.ADMIN]: false },
    '3.19.6': { [VIEWS.BT]: false, [VIEWS.ADMIN]: false },
    '3.19.7': { [VIEWS.BT]: false, [VIEWS.ADMIN]: false },
    '3.19.8': { [VIEWS.BT]: false, [VIEWS.ADMIN]: false },
    '3.19.9': { [VIEWS.BT]: true, [VIEWS.ADMIN]: true },
    '3.19.10': { [VIEWS.BT]: true, [VIEWS.ADMIN]: true },
    '3.19.11': { [VIEWS.BT]: false, [VIEWS.ADMIN]: true },
    '3.19.12': { [VIEWS.BT]: false, [VIEWS.ADMIN]: false },
    '3.19.13': { [VIEWS.BT]: false, [VIEWS.ADMIN]: false },
    '3.20.0': { [VIEWS.BT]: false, [VIEWS.ADMIN]: false },
    '3.20.1': { [VIEWS.BT]: true, [VIEWS.ADMIN]: false },
    '3.20.2': { [VIEWS.BT]: true, [VIEWS.ADMIN]: true },
    '3.20.3': { [VIEWS.BT]: true, [VIEWS.ADMIN]: false },
    '3.20.4': { [VIEWS.BT]: true, [VIEWS.ADMIN]: false },
    '3.20.5': { [VIEWS.BT]: true, [VIEWS.ADMIN]: false },
    '3.20.6': { [VIEWS.BT]: true, [VIEWS.ADMIN]: false },
    '3.20.7': { [VIEWS.BT]: false, [VIEWS.ADMIN]: false },
}

const getViewsRefreshByVersion = (clientVersion = '') => {
    const version = (clientVersion).split('.').map(item => parseInt(item)).filter(item => !isNaN(item));
    if (version.length !== 3) return defaultRefresh;

    // Check to see if clientVersion > APP_VERSION (current), if so refresh all
    // This situation will happen when client side is updated but not server side due to multiple server running at once
    const [major, minor, patches] = version;
    if (MAJOR < major || MINOR < minor || PATCHES < patches) {
        return defaultRefresh;
    }

    // If client version is the same as server then we don't need to refresh
    if (clientVersion === APP_VERSION) {
        return { [VIEWS.BT]: false, [VIEWS.ADMIN]: false };
    }

    // We need to use current APP_VERSION on the server to return where views needs to be refresh
    return get(refreshByVersion, APP_VERSION, defaultRefresh);
}

module.exports = { API_VERSION, API_VALID_VERSIONS, APP_VERSION, getViewsRefreshByVersion, VIEWS };